import type { VisioRole } from '@jeraisonne/visio';

/**
 * Dérive le rôle visio d'un compte CONNECTÉ (jamais un invité anonyme — ceux-ci
 * n'ont pas de `profiles.role`, cf. `join_visio_room_by_invite`, migration 0259) :
 * tuteur/admin → hôte (`'tutor'`), tout autre rôle connu → `'student'`.
 */
export function deriveVisioRole(role: string | null | undefined): VisioRole {
  return role === 'tutor' || role === 'admin' ? 'tutor' : 'student';
}
